/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { SidebarGlobal } from "./_Sidebar";
import Auth from "../shared/Auth";
import Icon from "./Icon";
import L from "./Lang";

class Administration extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
        SidebarGlobal.clearSubNav();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Administration</L></h1>
            <div className="list-group">
                {this.state.MODEL !== 'MST' && <>
                    {Auth.hasRole('account-manager') && <Link to="/account" className="list-group-item"><Icon icon="faHouse" /> <L>Accounts</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/data/Category" className="list-group-item"><Icon icon="faLayerGroup" /> <L>Categories</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/contact" className="list-group-item"><Icon icon="faAddressBook" /> <L>Contacts</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/data" className="list-group-item"><Icon icon="faDatabase" /> <L>Data Manager</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/manage/document-category" className="list-group-item"><Icon icon="faFolderOpen" /> <L>Document Categories</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/form/type/list" className="list-group-item"><Icon icon="faBorderNone" /> <L>Forms</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/group" className="list-group-item"><Icon icon="faUsersRectangle" /> <L>Groups</L></Link>}
                    {Auth.hasRole('admin') && this.state.MODEL === 'LIS' && <Link to="/lab/manager" className="list-group-item"><Icon icon="faGears" /> <L>Lab Management</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/manufacturer/list" className="list-group-item"><Icon icon="faIndustry" /> <L>Manufacturers</L></Link>}
                    {false && Auth.hasRole('manager') && <Link to="/medical-procedure" className="list-group-item"><Icon icon="faBedPulse" /> <L>Medical Procedures</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/manage/next-action" className="list-group-item"><Icon icon="faForward" /> <L>Next Actions</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/organization" className="list-group-item"><Icon icon="faSitemap" /> <L>Organizations</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/practice" className="list-group-item"><Icon icon="faStethoscope" /> <L>Practices</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/product" label="Products" className="list-group-item"><Icon icon="faBox" /> <L>Products</L></Link>}
                    {Auth.hasRole('manager') && <Link to="/provider" className="list-group-item"><Icon icon="faUserDoctor" /> <L>Providers</L></Link>}
                    {Auth.hasRole('admin') && <Link to="/settings" className="list-group-item"><Icon icon="faToolbox" /> <L>Settings</L></Link>}
                    {Auth.hasRole('survey') && <Link to="/survey" className="list-group-item"><Icon icon="faCircleQuestion" /> <L>Survey</L></Link>}
                    {Auth.hasRole('master') && <Link to="/role" className="list-group-item"><Icon icon="faBuildingShield" /> <L>Roles</L></Link>}
                </>}
                {Auth.hasRole('admin') && <Link to="/user" className="list-group-item"><Icon icon="faUsers" /> <L>Users</L></Link>}
                {this.state.MODEL !== 'MST' && <>
                    {Auth.hasRole('manager') && <Link to="/workflow" className="list-group-item"><Icon icon="faArrowsTurnToDots" /> <L>Workflows</L></Link>}
                </>}
                {Auth.hasRole('admin') && <Link to="/auditlog" className="list-group-item"><Icon icon="faBarsStaggered" /> <L>Audit Log</L></Link>}
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(Administration);